import { UIElement, UIElementType, UIEntityReference, UIEmbeddedEntity, Entity } from '#types/System.types';

/** Represents an entity reference element extracted from a UI layout structure with editor-specific properties like dndId */
export type ExtractedEntityReferenceElement = {
  dndId: string;
  entityId: string;
  entityGroupId?: string;
  label: string;
  type: 'entityReference';
  element: UIEntityReference | UIEmbeddedEntity;
};

/** Recursively traverses a UI element tree, invoking a callback for each element */
const traverse = (
  element: UIElement,
  callback: (element: UIElement) => void
): void => {
  callback(element);
  
  if ('children' in element && Array.isArray(element.children)) {
    element.children.forEach(child => traverse(child, callback));
  }
};

/** Extracts all entity reference elements from a UI layout structure including editor properties like dndId */
const extractEntityReferenceElements = (
  structure: UIElement,
  entities: Entity[]
): ExtractedEntityReferenceElement[] => {
  const references: ExtractedEntityReferenceElement[] = [];

  traverse(structure, (element) => {
    if (element.uiElementType === UIElementType.EntityReference ||
        element.uiElementType === UIElementType.EmbeddedEntity) {
      const ref = element as (UIEntityReference | UIEmbeddedEntity) & { dndId: string };
      if (ref.entityId && ref.dndId) {
        const entity = entities.find(e => e.docId === ref.entityId);
        let label = entity?.description?.shortLabel || ref.entityId;
        
        if (ref.entityGroupId) {
          const group = entity?.recordGroups?.[ref.entityGroupId];
          label = group?.description?.shortLabel || ref.entityGroupId;
        }
        
        references.push({
          dndId: ref.dndId,
          entityId: ref.entityId,
          entityGroupId: ref.entityGroupId,
          label,
          type: 'entityReference',
          element: ref
        });
      }
    }
  });

  return references;
};

export default extractEntityReferenceElements;

